import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=582b7896&scoped=true&lang=pug&"
import script from "./detailDialog.vue?vue&type=script&lang=js&"
export * from "./detailDialog.vue?vue&type=script&lang=js&"
import style0 from "./detailDialog.vue?vue&type=style&index=0&id=582b7896&prod&lang=less&scoped=true&"
import style1 from "./detailDialog.vue?vue&type=style&index=1&id=582b7896&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b7896",
  null
  
)

export default component.exports